import axios from 'axios';

const list = (data) => axios.get('/custom/team/list', data);
const save = (data) => axios.post('/custom/team/saveOrUpdate', data);
const del = (data) => axios.post('/custom/team/delete', data); //delete

export default {
  list,
  save,
  del,
}


